import React from "react";

const TimerIconBg = ({
  width = "14px",
  height = "14px",
  fill = "#F97316",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.3335 8.00004C1.3335 4.31804 4.31816 1.33337 8.00016 1.33337C11.6822 1.33337 14.6668 4.31804 14.6668 8.00004C14.6668 11.682 11.6822 14.6667 8.00016 14.6667C4.31816 14.6667 1.3335 11.682 1.3335 8.00004ZM8.66683 4.66671C8.66683 4.4899 8.59659 4.32033 8.47157 4.1953C8.34654 4.07028 8.17697 4.00004 8.00016 4.00004C7.82335 4.00004 7.65378 4.07028 7.52876 4.1953C7.40373 4.32033 7.3335 4.4899 7.3335 4.66671V7.17604C7.33351 7.54741 7.43692 7.91144 7.63214 8.22735C7.82736 8.54326 8.10669 8.79858 8.43883 8.96471L10.3688 9.92937C10.4474 9.97175 10.5337 9.99791 10.6226 10.0063C10.7115 10.0147 10.8011 10.0051 10.8863 9.97822C10.9714 9.9513 11.0503 9.90756 11.1182 9.84958C11.1861 9.79161 11.2416 9.72059 11.2815 9.64073C11.3215 9.56087 11.3449 9.47381 11.3506 9.38471C11.3562 9.2956 11.3439 9.20627 11.3144 9.12202C11.2848 9.03777 11.2387 8.9603 11.1786 8.89423C11.1186 8.82816 11.0459 8.77481 10.9648 8.73737L9.0355 7.77204C8.92478 7.71671 8.83164 7.63165 8.76653 7.52639C8.70142 7.42113 8.66689 7.29981 8.66683 7.17604V4.66671Z"
        fill={fill}
      />
    </svg>
  );
};

export default TimerIconBg;
